import { useEffect, useRef } from 'react'

import {
  useAccessToken,
  useDecodedAccessToken,
} from '@b-stock/fe-core/bstock-next/components'
import { getViewedListingsClient } from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'

import { useListingViewTracking } from '@/helpers/telemetry/ListingViewTrackingProvider'

export const useRecordListingView = ({ listingId }: { listingId: string }) => {
  const accessToken = useAccessToken()
  const decoded = useDecodedAccessToken()
  const personId = decoded?.personId
  const { trackListingView } = useListingViewTracking()

  const hasFiredRef = useRef<string | null>(null)

  useEffect(() => {
    if (!personId || !listingId) return

    const key = `${personId}:${listingId}`
    if (hasFiredRef.current === key) return
    hasFiredRef.current = key

    getViewedListingsClient()
      .upsertViewedListing(
        { personId, listingId },
        buildAxiosRequestConfig({ accessToken })
      )
      .catch(() => {
        // fire-and-forget: recording a view is non-critical
      })

    trackListingView(listingId)
  }, [personId, listingId, accessToken, trackListingView])
}
